export default "__VITE_ASSET__BmHuI8he__"